(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-select"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-select"], factory);
	else if(typeof exports === 'object')
		exports["ReactObjectForm"] = factory(require("react"), require("react-select"));
	else
		root["ReactObjectForm"] = factory(root["React"], root["Select"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition